var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Página não encontrada")]),_c('img',{attrs:{"src":"/img/404.svg","width":"500px","alt":"Pagina não encontrada"}}),_c('router-link',{staticClass:"retornar",attrs:{"to":"/login"}},[_vm._v("Retornar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }